module.exports = __webpack_public_path__ + "img/L2_zoom.fb8b251d.svg";